import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'

const CheckboxFilter = ({
  filterHandler,
  textOK = 'OK'
}) => {
  const checkboxRef = useRef(null)

  const isFiltered = (targetValue) => {
    if (targetValue === 'active') {
      return checkboxRef.current?.checked
    }
    return false
  }

  const handleFilterChange = () => {
    const isChecked = checkboxRef.current?.checked

    if (!isChecked) {
      // All checkboxes are checked means we want to remove the filter
      filterHandler()
    } else {
      filterHandler({ callback: isFiltered })
    }
  }

  useEffect(() => {
    filterHandler({ callback: isFiltered })
  }, [])

  return (
    <div style={{ alignItems: 'center', display: 'inline-flex', marginTop: '4px', maxHeight: '8px' }}>
      <input
        style={{ marginBottom: '14px' }}
        ref={checkboxRef}
        type="checkbox"
        className="filter"
        onChange={handleFilterChange}
        defaultChecked
      />

      <label style={{ marginBottom: '8px', paddingLeft: '5px' }}>
        {textOK}
      </label>
    </div>
  )
}

CheckboxFilter.propTypes = {
  filterHandler: PropTypes.func.isRequired,
  textOK: PropTypes.string,
}

export default CheckboxFilter
